import { getSetupCopy } from "@/features/i18n/setupCopy";
import type { SupportedLocale } from "@patient-watch/i18n";
import type { StatefulDiaryT } from "@patient-watch/types";
import { getReferenceDateContextFromDiary, type ReferenceDateContext } from "./getProcedureInformationFromDiary";

interface ReferenceDateFieldCopyLabels {
    baselineDate: string;
    baselineDateDescription: string;
    patientBaselineDate: string;
    patientBaselineDateDescription: string;
    eventDateDescription: string;
    patientEventDateDescription: string;
}

export interface ReferenceDateFieldCopy {
    label: string;
    description: string;
}

/**
 * Label + description for a reference date field. Tied to the event when there is one
 * ("Date of injection"), otherwise a baseline date (registries, studies with no intervention).
 */
export function getReferenceDateFieldCopy(
    context: ReferenceDateContext,
    copy: ReferenceDateFieldCopyLabels,
    locale: SupportedLocale,
    isPatient: boolean
): ReferenceDateFieldCopy {
    if (!context.heading) {
        return isPatient
            ? { label: copy.patientBaselineDate, description: copy.patientBaselineDateDescription }
            : { label: copy.baselineDate, description: copy.baselineDateDescription };
    }
    return {
        label: getSetupCopy(locale).getReferenceDateSetupCopy(context.heading, context.kind).fieldLabel,
        description: isPatient ? copy.patientEventDateDescription : copy.eventDateDescription,
    };
}

/** Patient-facing label for the diary's reference date, e.g. "Date of injection" or "Start date". */
export function getPatientReferenceDateLabel(
    diary: StatefulDiaryT,
    copy: ReferenceDateFieldCopyLabels,
    locale: SupportedLocale
): string {
    return getReferenceDateFieldCopy(getReferenceDateContextFromDiary(diary, locale), copy, locale, true).label;
}
